import { action, computed, makeObservable, observable } from 'mobx';
import { getCookie, setCookie } from 'utils/cookies';
import { IInvestment, ViewModeCookieName } from 'utils/globalTypes';
import { getObjProperty } from 'utils/object';

class AssetStore {
  mapAssets: IInvestment[] = [];
  assetBrowsingView = {
    assetBrowsingMapView: false,
    assetBrowsingTableView: false
  };
  portfolioBrowsingView = {
    assetBrowsingMapView: false,
    assetBrowsingTableView: false
  };
  selectedItemId = '';
  activeItemId = '';

  mapInteraction = false;
  mapLoaded = false;

  constructor() {
    makeObservable(this, {
      assetBrowsingView: observable,
      portfolioBrowsingView: observable,
      mapInteraction: observable,
      mapLoaded: observable,
      selectedItemId: observable,
      activeItemId: observable,
      mapAssets: observable,

      setMapAssets: action,
      clearMapAssets: action,
      setActiveItem: action,
      clickHandler: action,
      clearSelected: action,
      clearMap: action,

      setAssetBrowsingView: action,
      setAssetBrowsingTableView: action,
      setAssetBrowsingMapView: action,

      getMapAssets: computed
    });
  }

  setMapAssets(assets?: IInvestment[]) {
    this.mapAssets = assets || [];
  }

  setActiveItem(item: IInvestment, state: boolean) {
    if (state) {
      this.activeItemId = item.offering_id || '';
    } else if (this.activeItemId == item.offering_id) {
      this.activeItemId = '';
    }
  }

  setToggleItem(item: IInvestment, itemFiled: string, state: boolean) {
    item[itemFiled] = state;
  }

  clickHandler(item: IInvestment) {
    if (this.selectedItemId == item.offering_id) {
      this.selectedItemId = '';
    } else {
      this.selectedItemId = item.offering_id || '';
    }
  }

  clearSelected(item?: IInvestment) {
    if (!item || this.selectedItemId == item.offering_id) {
      this.selectedItemId = '';
    }
    if (!item || this.activeItemId == item.offering_id) {
      this.activeItemId = '';
    }
  }

  initAssetBrowsingView(
    defaultValue?: string,
    cookieName: ViewModeCookieName = 'assetBrowsingView'
  ) {
    const viewCookie = getCookie(cookieName);

    this.setAssetBrowsingView(viewCookie, defaultValue, cookieName);
  }

  setAssetBrowsingView(
    key?: Record<string, unknown>,
    defaultValue?: string,
    cookieName?: ViewModeCookieName
  ) {
    const tableView = 'assetBrowsingTableView';
    const mapView = 'assetBrowsingMapView';
    this.setAssetBrowsingTableView(
      Boolean(getObjProperty(key, tableView, defaultValue === tableView)),
      cookieName
    );
    this.setAssetBrowsingMapView(
      Boolean(getObjProperty(key, mapView, defaultValue === mapView)),
      cookieName
    );
  }

  setAssetBrowsingTableView(value: boolean, cookieName: ViewModeCookieName = 'assetBrowsingView') {
    this[cookieName].assetBrowsingTableView = value;

    setCookie(cookieName, {
      assetBrowsingTableView: value,
      assetBrowsingMapView: this[cookieName].assetBrowsingMapView
    });
  }

  setAssetBrowsingMapView(value: boolean, cookieName: ViewModeCookieName = 'assetBrowsingView') {
    this[cookieName].assetBrowsingMapView = value;

    setCookie(cookieName, {
      assetBrowsingTableView: this[cookieName].assetBrowsingTableView,
      assetBrowsingMapView: value
    });
  }

  clearMap() {
    this.mapLoaded = false;
    this.mapInteraction = false;
    this.activeItemId = '';
    this.selectedItemId = '';
  }

  clearMapAssets() {
    this.mapAssets = [];
  }

  get getMapAssets() {
    return this.mapAssets;
  }
}

export default AssetStore;
